import type { Maybe } from '@custom/dx3';
import { Link } from '@custom/dx3';
import { CaretRightIcon } from '../../assets/svgs';

import styles from './ArticleDisplayStyles.module.scss';

type ArticleDisplayProps = {
  iconUrl: Maybe<string>;
  iconAltText: Maybe<string>;
  title: Maybe<string>;
  summary: Maybe<string>;

  url: string;
};
export function ArticleDisplay({
  iconUrl,
  iconAltText,
  title,
  summary,
  url,
}: ArticleDisplayProps): JSX.Element {
  return (
    <Link href={url} className={styles['article-display']}>
      {iconUrl && (
        <div className={styles['icon-container']}>
          <img src={iconUrl} alt={iconAltText ?? ''} />
        </div>
      )}
      <div className={styles['text-container']}>
        <p className={styles['title']}>{title}</p>
        <p className={styles['summary']}>{summary}</p>
      </div>
      <div className={styles['caret-container']}>
        <CaretRightIcon />
      </div>
    </Link>
  );
}
